import React, { useState, useEffect, useContext } from "react";
import { UrlContext } from "../../contexts/UrlContext";

function ContactListForList({ expertID }) {
  const [logData, setLogData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropDownRef = React.createRef();
  const [showContactLog, setShowContactLog] = useState(false);
  const { API_URL } = useContext(UrlContext);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API_URL}contact-log-for-list/${expertID}`
      );

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      const data = await response.json();
      setLogData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setTimeout(() => {
          setShowContactLog(false);
        }, 100);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropDownRef]);

  return (
    <div className="pjdetails-dropdown" ref={dropDownRef}>
      <button className="pjdetails-dropbtn" onClick={toggleDropdown}>
        <i
          className={`fa-solid ${isOpen ? "fa-chevron-up" : "fa-chevron-down"}`}
        ></i>
      </button>
      {isOpen && (
        <div className="pjdetails-dropdown-content">
          {logData.length > 0 ? (
            logData.map((data, index) => {
              return (
                <span key={index} className="pjdetails-log-content">
                  {data.contactedBy}: {data.contactMethod} at{" "}
                  <input
                    type="datetime-local"
                    value={new Date(data.dateContacted)
                      .toISOString()
                      .slice(0, 16)}
                    readOnly
                  />{" "}
                  for {data.contactedFor}
                </span>
              );
            })
          ) : (
            <p className="pjdetails-log-content">
              No information available yet!
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default ContactListForList;
